import { createFileRoute, redirect } from "@tanstack/react-router";
import CreateUsersPage from "../../../../pages/UsersPage/CreateUsersPage";

export const Route = createFileRoute("/(app)/users/create/")({
  beforeLoad: () => {
    throw redirect({ to: "/users/create/new" });
  },
});
